<script>
  import { browser } from "$app/environment";

  let isOffline = false;

  if (browser) {
    isOffline = !navigator.onLine;
    const update = () => (isOffline = !navigator.onLine);
    window.addEventListener("online", update);
    window.addEventListener("offline", update);
  }
</script>

{#if isOffline}
  <div class=" bg-[#4C9EEA] text-white p-[8px]">
  <a class=" text-[16px]">⚠️ 当前处于离线状态</a>
</div>
{/if}


